import _ from "lodash";

const combinedMedicines = (medicalDocuments) =>
  _(medicalDocuments)
    .flatMap("medicines")
    .compact()
    .uniqBy((medicine) => medicine.externalId || medicine.text)
    .value();

export default combinedMedicines;
